// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-all-tags-index-js": () => import("/home/jamiebones/Gatsby_Projects/TonyBlog/src/templates/allTagsIndex.js" /* webpackChunkName: "component---src-templates-all-tags-index-js" */),
  "component---src-templates-single-tag-index-js": () => import("/home/jamiebones/Gatsby_Projects/TonyBlog/src/templates/singleTagIndex.js" /* webpackChunkName: "component---src-templates-single-tag-index-js" */),
  "component---src-templates-blog-post-js": () => import("/home/jamiebones/Gatsby_Projects/TonyBlog/src/templates/blogPost.js" /* webpackChunkName: "component---src-templates-blog-post-js" */),
  "component---src-pages-index-js": () => import("/home/jamiebones/Gatsby_Projects/TonyBlog/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/home/jamiebones/Gatsby_Projects/TonyBlog/.cache/data.json")

